<div class="text-center py-5 md:py-8">
  <p class="mb-4">No settlements to show!</p>
  <img src="/assets/img/img-empty-state-settlements.svg" alt="Image">
</div>